import { Badge } from '@/components/ui/badge'
import { Platform } from '@/types'
import { getPlatformLabel } from '@/constants/platforms'

interface PlatformBadgeProps {
  platform: Platform
  variant?: 'default' | 'secondary' | 'outline'
  size?: 'sm' | 'default'
  className?: string
}

const getPlatformBadgeColor = (platform: Platform): string => {
  switch (platform) {
    case 'bolt': return 'bg-[#2a9c64] text-white border-[#2a9c64]'
    case 'uber': return 'bg-black text-white border-black'
    case 'sumup': return 'bg-[#4ac8ea] text-white border-[#4ac8ea]'
    case 'friåkning': return 'border-cyan-500 text-cyan-700 bg-cyan-50'
    case 'other': return 'border-gray-500 text-gray-700 bg-gray-50'
    default: return 'border-gray-500 text-gray-700 bg-gray-50'
  }
}

export function PlatformBadge({
  platform,
  variant = 'outline',
  size = 'sm',
  className = ''
}: PlatformBadgeProps) {
  const platformColors = getPlatformBadgeColor(platform)
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-1' : ''

  return (
    <Badge
      variant={variant}
      className={`${platformColors} ${sizeClass} ${className}`}
    >
      {getPlatformLabel(platform)}
    </Badge>
  )
}